import i18n from '@/i18n';
import { getValidityFilterOptions, VALIDITY_FILTERS } from '@modules/logic/dailyTripValidity';

import AppSelect from '../select/AppSelect';

/**
 * ValidityFilterSelect — la tendina "che pianificati mostrare".
 *
 * Le liste di pianificati sono quattro (lista corse, car pooling, scheda
 * azienda, scheda utente) e la domanda è sempre la stessa: sto guardando quello
 * che vale adesso, quello che partirà, o anche la storia chiusa? Tenendo il
 * controllo in un componente solo, le voci e il loro ordine restano identici
 * ovunque — un filtro che si chiama diversamente da una pagina all'altra è un
 * filtro che l'operatore non si fida a usare.
 *
 * Il valore non riconosciuto non seleziona nulla (`?? null`) invece di lasciare
 * il campo con l'ultima etichetta valida: lo stato può arrivare riesumato da
 * Redux/localStorage con un modo che non esiste più.
 *
 * @param {string} props.value modo corrente (`VALIDITY_FILTERS`)
 * @param {(mode: string) => void} props.onChange
 */
export default function ValidityFilterSelect({
  value,
  onChange,
  minWidth = 190,
  placeholder,
  className,
  ...rest
}) {
  // Le label passano da i18n: si rileggono a ogni render (sei oggetti, costo
  // nullo), così un cambio lingua non lascia la tendina in quella del primo import.
  const options = getValidityFilterOptions();

  return (
    <div className={className} style={{ minWidth }}>
      <AppSelect
        options={options}
        value={options.find((o) => o.value === value) ?? null}
        onChange={(opt) => onChange?.(opt?.value || VALIDITY_FILTERS.ALL)}
        placeholder={placeholder ?? i18n.t('validita', { defaultValue: 'Validità' })}
        isSearchable={false}
        {...rest}
      />
    </div>
  );
}
